export default angular.module("NiabCufApp", [
    "NiabCufApp.irrigation"]);